import devLog from 'core/utils/devLog';

export default function gaEvent(eventCategory, eventAction, eventLabel=undefined, eventValue=undefined) {
	let evtParams = {
		'event_category': eventCategory,
	};

	if (eventLabel !== undefined) {
		evtParams['event_label'] = eventLabel;
	}

	if (eventValue !== undefined) {
		evtParams['value'] = eventValue;
	}

	devLog("gtag(event)", eventAction, evtParams);
	if (typeof window !== 'object' || !window.gtag ) {
		return;
	}

	window.gtag('event', eventAction, evtParams);
}
